import {RSFormHelper} from '../../be/redskythirty/helpers/form';
import {RSValidationHelper} from '../../be/redskythirty/helpers/validation';
import {RSUrlRequest} from '../../be/redskythirty/net/url-request';

import Swal from 'sweetalert2';


export class LandingView
{
	/**
	 * @param {HTMLElement} elPageBody
	 */
	constructor(elPageBody)
	{
		const _class = this;
		const elsTeamMails = elPageBody.querySelectorAll('.js-team-email');
		
		if (elsTeamMails.length > 0)
		{
			for (const elTeamEmail of elsTeamMails)
			{
				elTeamEmail.addEventListener('click', (event) => {
					/*if (event.currentTarget.getAttribute('href') === '#')
					{
						event.preventDefault();
						
						_class._loadTeamEmail(event.currentTarget);
					}*/
					
					event.preventDefault();
					
					_class._loadTeamEmail(event.currentTarget);
				});
			}
		}
		
		const elFormContact = elPageBody.querySelector('form[name="contact"]');
		
		if (elFormContact != null)
		{
			elFormContact.querySelector('button[type="submit"]').addEventListener('click', (event) => {
				event.preventDefault();
				
				const _this = event.currentTarget;
				
				_this.setAttribute('disabled', 'disabled');
				elFormContact.style.pointerEvents = 'none';
				
				const data = RSFormHelper.serialize(elFormContact);
				
				let success = RSFormHelper.checkRequired(elFormContact, data);
				
				if (success)
				{
					const elInputEmail = elFormContact.querySelector('input[name="email"]');
					
					if (!RSValidationHelper.isEmailValid(data['email']))
					{
						success = false;
						
						RSFormHelper.addValidationClassToField(elInputEmail, false, false);
					}
					else
					{
						RSFormHelper.addValidationClassToField(elInputEmail, true, true);
					}
				}
				
				if (success)
				{
					const urlRequest = new RSUrlRequest();
					
					urlRequest.on(RSUrlRequest.EVENT_ERROR, (event) => {
						Swal.fire({
							title: 'Sorry!',
							text: 'Something went wrong... (gte468sa0gy5)',
							icon: 'error',
							confirmButtonColor: '#14a697'
						});
					});
					
					urlRequest.on(RSUrlRequest.EVENT_COMPLETE, (event) => {
						_this.removeAttribute('disabled', 'disabled');
						elFormContact.style.pointerEvents = null;
						
						if (event.data.success)
						{
							Swal.fire({
								title: event.data.confirmation.title,
								text: event.data.confirmation.message,
								icon: 'success',
								confirmButtonColor: '#14a697'
							});
							
							RSFormHelper.reset(elFormContact);
						}
						else
						{
							Swal.fire({
								title: event.data.error.title,
								text: event.data.error.message,
								icon: 'error',
								confirmButtonColor: '#14a697'
							});
						}
					});
					
					urlRequest.postData(elFormContact.getAttribute('action'), data);
				}
				else
				{
					_this.removeAttribute('disabled');
					elFormContact.style.pointerEvents = null;
				}
			});
		}
	}
	
	
	//
	// Private Methods
	//
	
	/**
	 * @param {HTMLElement} elLink
	 * @private
	 */
	_loadTeamEmail(elLink)
	{
		const urlRequest = new RSUrlRequest();
		
		urlRequest.on(RSUrlRequest.EVENT_ERROR, (event) => {
			Swal.fire({
				title: 'Sorry!',
				text: 'Something went wrong... (asr458xsm03e1)',
				icon: 'error',
				confirmButtonColor: '#14a697'
			});
		});
		
		urlRequest.on(RSUrlRequest.EVENT_COMPLETE, (event) => {
			if (event.data.success)
			{
				/*elLink.setAttribute('href', `mailto:${event.data.email}`);
				elLink.click();*/
				
				window.location.href = `mailto:${event.data.email}`;
			}
			else
			{
				Swal.fire({
					title: 'Sorry!',
					text: 'Something went wrong... (asr458xsm03e2)',
					icon: 'error',
					confirmButtonColor: '#14a697'
				});
			}
		});
		
		urlRequest.postData(BASE_URL + elLink.getAttribute('data-uri'), {
			name: elLink.closest('.js-team-info').querySelector('.js-team-name').textContent
		});
	}
}
